import widgetInit from '../widgetCore';
import Carousel from '../widgetCore/Carousel';
import FinnCarousel from '../widgetCore/FinnCarousel';
import { fetcher } from '../widgetCore/helpers';
import Statistic from './Statistic';
import ParentReceiver from './Receiver';
import ParentSender from './Sender';

const statistic = new Statistic({
  fetcher
});

const parentReceiver = new ParentReceiver();
const parentSender = new ParentSender();

const mainSliderContainer = document.getElementById('slider-tiles-container');

const isFinn = mainSliderContainer.classList.contains('finn');
const CarouselClass = isFinn ? FinnCarousel : Carousel;
const carousel = new CarouselClass({
  mainContainer: mainSliderContainer
});

widgetInit({
  statistic,
  parentReceiver,
  parentSender,
  mainSliderContainer,
  carousel
});
